import { faCoins, faMoneyBill, faShieldAlt, faUser, faUserHairLong } from '@fortawesome/pro-solid-svg-icons';
import { useEffect } from 'react';

import Description from '../../components/Description/Description';
import Icon from '../../components/Icon/Icon';
import ListField from '../../components/ListField/ListField';
import PagesFooter from '../../components/PagesFooter/PagesFooter';
import PagesHeader from '../../components/PagesHeader/PagesHeader';
import Title from '../../components/Title/Title';
import { usePagesContext } from '../../context/PagesContext';
import EventApplicationStartHelper from '../../helpers/EventApplicationStartHelper';
import { useAppDispatch } from '../../hooks';
import { useAppSelector } from '../../hooks';
import useComponentTracker from '../../hooks/useComponentTracker';
import useDefaultPagesAction from '../../hooks/useDefaultPagesAction';
import usePagesConfig from '../../hooks/usePagesConfig';
import useSetBannerType from '../../hooks/useSetBannerType';
import useSettings from '../../hooks/useSettings';
import useTranslation from '../../hooks/useTranslation';
import { addOrUpdateFormField } from '../../store/applicationform';
import { selectFieldStateByName } from '../../store/applicationform/applicationFormSelectors';
import { IFieldState } from '../../store/applicationform/applicationFormTypes';

const HowToApplyPage = () => {
    const translate = useTranslation();
    const dispatch = useAppDispatch();
    const { totalSections } = usePagesConfig();
    const { currentPage } = usePagesContext();
    useComponentTracker('HowToApplyPage');
    const defaultPagesAction = useDefaultPagesAction();
    useSetBannerType('bannerZero');
    const { applicationId } = useAppSelector((state) => state.application);
    const { countryCode } = useSettings();
    const useConsolidation = useAppSelector(selectFieldStateByName)('useConsolidation')?.value;

    useEffect(() => {
        dispatch(
            addOrUpdateFormField({
                fieldName: 'version',
                value: '1',
            } as IFieldState),
        );
    }, [dispatch]);

    return (
        <>
            <EventApplicationStartHelper
                applicationId={applicationId}
                currentPage={currentPage}
                countryCode={countryCode}
            />
            <PagesHeader
                actions={['back']}
                onAction={defaultPagesAction}
                currentPage={currentPage}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={0}
                currentPageInSection={0}
                sectionTitle={translate('field.section.about-you')}
            />
            <Title text={translate('page.how-to-apply.title')} />
            <Description text={translate('page.how-to-apply.description')} />
            <ListField
                name="howToApplySteps"
                hideDivider
                items={[
                    {
                        index: '1',
                        icon: <Icon icon={faUser} color="secondary" />,
                        label: translate('page.how-to-apply.subtitle.contact-details'),
                    },
                    {
                        index: '2',
                        icon: <Icon icon={faCoins} color="secondary" />,
                        label: translate('page.how-to-apply.subtitle.expenses'),
                    },
                    {
                        index: '3',
                        icon: <Icon icon={faShieldAlt} color="secondary" />,
                        label: translate('page.how-to-apply.subtitle.sign'),
                    },
                    {
                        index: '4',
                        icon: <Icon icon={faMoneyBill} color="secondary" />,
                        label: translate(
                            useConsolidation
                                ? 'page.how-to-apply.subtitle.consolidation'
                                : 'page.how-to-apply.subtitle.consolidation.optional',
                        ),
                    },
                    {
                        index: '6',
                        icon: <Icon icon={faUserHairLong} color="secondary" />,
                        label: translate('page.how-to-apply.subtitle.co-applicant'),
                    },
                ]}></ListField>
            <PagesFooter
                actions={['next']}
                onAction={defaultPagesAction}
                currentSection={0}
                numberOfSections={totalSections}
                numberOfPagesInSection={0}
                currentPageInSection={0}
                sectionTitle={translate('field.section.about-you')}
            />
        </>
    );
};

export default HowToApplyPage;
